var map = {
	"./defaultCodeAdvanced.json": 3836,
	"./defaultCodeSimple.json": 3837,
	"./defaultCodeSimple2.json": 3838,
	"./defaultCodeTracks.json": 3839,
	"./music-instructions.json": 3840,
	"./music-library.json": 3841,
	"./music-progression.json": 3842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3126;